import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";

import palette from "./palette";

const theme = responsiveFontSizes(
  createTheme({
    palette,
    layout: {
      contentWidth: "85vw",
    },
    typography: {
      fontFamily: '"Inter","Lato", sans-serif',
      button: {
        textTransform: "none",
      },
    },
    zIndex: {
      appBar: 1200,
      drawer: 1100,
    },
    overrides: {
      MuiButton: {
        containedSecondary: {
          color: "white",
        },
      },
    },
  }),
);

export default theme;
